import { useWorkspaceFetch } from '#layers/base/public';

interface RoleIdPayload {
	id: string;
}

export async function connectMemberRoles(memberId: string, roleIds: string[]): Promise<void> {
	if (roleIds.length === 0) return;

	const fetch = useWorkspaceFetch();
	const payload: RoleIdPayload[] = roleIds.map((id) => ({ id }));

	await fetch(`members/${memberId}/roles`, {
		method: 'POST',
		body: payload,
	});
}

export async function disconnectMemberRoles(memberId: string, roleIds: string[]): Promise<void> {
	if (roleIds.length === 0) return;

	const fetch = useWorkspaceFetch();
	const payload: RoleIdPayload[] = roleIds.map((id) => ({ id }));

	await fetch(`members/${memberId}/roles`, {
		method: 'DELETE',
		body: payload,
	});
}
